import { Canvas } from "@react-three/fiber";
import GameScene from "../components/GameScene";
import { useEffect, useRef, useState } from "react";
import { Hands, HAND_CONNECTIONS } from "@mediapipe/hands";
import { Camera } from "@mediapipe/camera_utils";
import { drawConnectors, drawLandmarks } from "@mediapipe/drawing_utils";
import * as tf from "@tensorflow/tfjs";
import './game.css';

import { Unity, useUnityContext } from "react-unity-webgl";
import Controls from "../components/Controls";



const classes = ['paper', 'rock', 'scissors'];


const keys_mapping = {
    "leftward": 37,
    "rightward_1": 85,
    "rightward_2": 73,
    "rightward_3": 79,
    "rightward_4": 80,
    "rightward": 39,
    "leftward_1": 72,
    "leftward_2": 74,
    "leftward_3": 75,
    "leftward_4": 76
};

function indexOfMax(arr) {
    if (arr.length === 0) {
        return -1;
    }
    var max = arr[0];
    var maxIndex = 0;
    for (var j = 1; j < arr.length; j++) {
        if (arr[j] > max) {
            maxIndex = j;
            max = arr[j];
        }
    }
    return maxIndex;
}

function getCurrentDimension(){
    if ((window.innerWidth < 720) && (window.innerHeight > window.innerWidth)) {
        return {
            width: window.innerWidth * 0.4,
            height: window.innerWidth * 0.4,
            screenWidth: window.innerWidth,
            screenHeight: window.innerHeight,
            modelSize: 1
        }
    } else if ((window.innerWidth < 1280) && (window.innerHeight < window.innerWidth)) {
        // window.alert('landscape');
        return {
            width: window.innerWidth * 0.2,
            height: window.innerWidth * 0.2,
            screenWidth: window.innerWidth,
            screenHeight: window.innerHeight,
            modelSize: 0
        }
    } else {
        return {
            width: 1280/3,
            height: 720/3,
            screenWidth: window.innerWidth,
            screenHeight: window.innerHeight,
            modelSize: 0
        }
    }
    // return {
    //   	width: window.innerWidth,
    //   	height: window.innerHeight
    // }
}


export default function Game() {
    // Prepare camera
    const [screenSize, setScreenSize] = useState(getCurrentDimension());
    // const [cameraSize, setCameraSize] = useState({width: 1280/3, height: 720/3})
    // const cam_width = 1280/3;
    // const cam_height = 720/3;
    useEffect(() => {
        const updateDimension = () => {
            setScreenSize(getCurrentDimension())
            // const dimensions = getCurrentDimension();
            // if (dimensions.width < 720) {
            //     window.alert("hellooooo");
            //     setCameraSize({width: 480/3, height: 520/3});
            // } else {
            //     setCameraSize({width: 1280/3, height: 720/3});
            // }

        }
        window.addEventListener('resize', updateDimension);

    
        return(() => {
            window.removeEventListener('resize', updateDimension);
        })
    }, [screenSize])

    // Draw landmarks
    const canvasRef = useRef(null);

    var accelerate = false;
    var brake = false;
    var turndir= "none";
    const styles = {
        three_container: {
            'width': '70vw',
            'height': '80vh',
        },
    };

    const videoElement = useRef(null);
    const model = tf.loadLayersModel("/rps_model/model.json");

    // predict the sign of a hand
    const predict = async (rps_features) => {
        if (!model) return 4;
        const features_tensor = tf.tensor2d(rps_features, [1, rps_features.length]);
        const model_outputs = await model.then(async (res) => {
            return await res.predict(features_tensor).array();
          });
        const model_prediction = classes[indexOfMax(model_outputs[0])];
        return model_prediction;
      };

    const [handSign, setHandSign] = useState("none");
    // process the results of mediapipe hand detection
    function onResults(results) {
        // Draw landmarks
        const canvas = canvasRef.current;
        const context = canvas.getContext("2d");
        context.clearRect(0, 0, canvas.width, canvas.height);
        
        // Draw landmarks for each detected hand
        results.multiHandLandmarks.forEach((landmarks) => {
            drawConnectors(context, landmarks, HAND_CONNECTIONS);
            drawLandmarks(context, landmarks, { color: "#FF0000", radius: 2 });
        });

        // Do nothing if less than 2 hands are detected
        if (results.multiHandLandmarks.length < 2) {
            const event = new CustomEvent("moveDirection", { detail: "none" });
            window.dispatchEvent(event);
        // Do something if 2 hands are detected
        } else if (results.multiHandLandmarks.length == 2) {
            // Get sign prediction for a single hand
            const get_sign = (landmarks) => {
                const maxX = Math.max(...landmarks.map(({ x }) => x));
                const maxY = Math.max(...landmarks.map(({ y }) => y));
                const minX = Math.min(...landmarks.map(({ x }) => x));
                const minY = Math.min(...landmarks.map(({ y }) => y));
                const normalizedCoordinates = landmarks.flatMap(({ x, y }) => [
                    2 * (x - minX) / (maxX - minX) - 1,
                    2 * (y - minY) / (maxY - minY) - 1,
                ]);
                const prediction = predict(normalizedCoordinates).then((res) => {
                    return res;
                });
                return prediction;
            }
            // Get the wheel's steering
            const get_turn = (hands, handednesses) => {
                const sensitivity = 0.4;
                var leftHand = null;
                var rightHand = null;
                var turn = "none";
                for (let i = 0; i < 2; i++) {
                    const maxX = Math.max(...hands[i].map(({ x }) => x));
                    const maxY = Math.max(...hands[i].map(({ y }) => y));
                    const minX = Math.min(...hands[i].map(({ x }) => x));
                    const minY = Math.min(...hands[i].map(({ y }) => y));
                    const center = {x: (maxX + minX)/2, y: (maxY + minY)/2};
                    if (handednesses[i].label == "Right") {
                        rightHand = center;
                    } else {
                        leftHand = center;
                    }
                }
                const slope = (rightHand.y - leftHand.y) / (rightHand.x - leftHand.x);
                if (Math.abs(slope) > sensitivity) {
                    if (slope > 0) {
                        turn = "leftward";
                    } else {
                        turn = "rightward";
                    }
                }
                if (turn == "none") {
                    return turn;
                } 
                const sharpness = Math.ceil((Math.abs(slope) - sensitivity)/0.2).toString();
                if (sharpness > 4){
                    return turn;
                } else {
                    return turn + "_" + sharpness;
                }
            }
            
            // Get sign prediction for both hands
            // const get_predictions_threejs = async () => {
            //     const predictions = results.multiHandLandmarks.map(landmarks => get_sign(landmarks));
            //     const resolvedPredictions = await Promise.all(predictions);
            //     const turn_direction = get_turn(results.multiHandLandmarks, results.multiHandedness);
            //     // accelerate
            //     if (resolvedPredictions.includes('paper')) {
            //         const event = new CustomEvent("moveDirection", { detail: "backward" });
            //         window.dispatchEvent(event);
            //     } else if (resolvedPredictions.includes('scissors')) {
            //         const event = new CustomEvent("moveDirection", { detail: "none" });
            //         window.dispatchEvent(event);
            //     } else {
            //         const event = new CustomEvent("moveDirection", { detail: "forward" });
            //         window.dispatchEvent(event);
            //     }
            //     // turn
            //     const event = new CustomEvent("turnDirection", { detail: turn_direction });
            //     window.dispatchEvent(event);
            // }
            const get_predictions = async () => {
                const predictions = results.multiHandLandmarks.map(landmarks => get_sign(landmarks));
                const resolvedPredictions = await Promise.all(predictions);
                const turn_direction = get_turn(results.multiHandLandmarks, results.multiHandedness);
                if (resolvedPredictions.includes('paper')) {
                    // brake
                    if (accelerate==true) {
                        accelerate=false;
                        const kb_event = new KeyboardEvent('keyup', {'keyCode': 38, 'which': 38});
                        window.dispatchEvent(kb_event);
                        // iframeRef.current.contentWindow.postMessage(JSON.parse(JSON.stringify(kb_event)), "*");
                        // iframeRef.current.contentWindow.dispatchEvent(kb_event);
                        // document.getElementsByClassName('iframegame')[0].contentWindow.postMessage(kb_event);
                    }
                    if (brake==false) {
                        brake=true;
                        const kb_event = new KeyboardEvent('keydown', {'keyCode': 40, 'which': 40});
                        window.dispatchEvent(kb_event);
                        // iframeRef.current.contentWindow.postMessage(JSON.parse(JSON.stringify(kb_event)), "*");
                        // iframeRef.current.contentWindow.dispatchEvent(kb_event);
                        // document.getElementsByClassName('iframegame')[0].contentWindow.postMessage(kb_event);
                    }
                } else if (resolvedPredictions.includes('scissors')) {
                    // do nothing
                    if (accelerate==true) {
                        accelerate=false;
                        const kb_event = new KeyboardEvent('keyup', {'keyCode': 38, 'which': 38});
                        window.dispatchEvent(kb_event);
                        // iframeRef.current.contentWindow.postMessage(JSON.parse(JSON.stringify(kb_event)), "*");
                        // iframeRef.current.contentWindow.dispatchEvent(kb_event);
                        // document.getElementsByClassName('iframegame')[0].contentWindow.postMessage(kb_event);
                    }
                    if (brake==true) {
                        brake=false;
                        const kb_event = new KeyboardEvent('keyup', {'keyCode': 40, 'which': 40});
                        window.dispatchEvent(kb_event);
                        // iframeRef.current.contentWindow.postMessage(JSON.parse(JSON.stringify(kb_event)), "*");
                        // iframeRef.current.contentWindow.dispatchEvent(kb_event);
                        // document.getElementsByClassName('iframegame')[0].contentWindow.postMessage(kb_event);
                    }
                } else {
                    // accelerate
                    if (accelerate==false) {
                        accelerate=true;
                        // console.log("accelerate is:", accelerate);
                        const kb_event = new KeyboardEvent('keydown', {'keyCode': 38, 'which': 38});
                        window.dispatchEvent(kb_event);
                        // iframeRef.current.contentWindow.postMessage(JSON.parse(JSON.stringify(kb_event)), "*");
                        // iframeRef.current.contentWindow.dispatchEvent(kb_event);
                        // document.getElementsByClassName('iframegame')[0].contentWindow.postMessage(kb_event);
                    }
                    if (brake==true) {
                        brake=false;
                        const kb_event = new KeyboardEvent('keyup', {'keyCode': 40, 'which': 40});
                        window.dispatchEvent(kb_event);
                        // iframeRef.current.contentWindow.postMessage(JSON.parse(JSON.stringify(kb_event)), "*");
                        // iframeRef.current.contentWindow.dispatchEvent(kb_event);
                        // document.getElementsByClassName('iframegame')[0].contentWindow.postMessage(kb_event);
                    }
                }

                // Sharp turn
                // if (turn_direction=="leftward") {
                //     if (turndir=="right") {
                //         turndir="left";
                //         const kb_event = new KeyboardEvent('keyup', {'keyCode': 39, 'which': 39});
                //         window.dispatchEvent(kb_event);
                //         const kb_event_2 = new KeyboardEvent('keydown', {'keyCode': 37, 'which': 37});
                //         window.dispatchEvent(kb_event_2);
                //     } else if (turndir=="none") {
                //         turndir="left";
                //         const kb_event = new KeyboardEvent('keydown', {'keyCode': 37, 'which': 37});
                //         window.dispatchEvent(kb_event);
                //     }
                // }
                // if (turn_direction=="rightward") {
                //     if (turndir=="left") {
                //         turndir="right";
                //         const kb_event = new KeyboardEvent('keyup', {'keyCode': 37, 'which': 37});
                //         window.dispatchEvent(kb_event);
                //         const kb_event_2 = new KeyboardEvent('keydown', {'keyCode': 39, 'which': 39});
                //         window.dispatchEvent(kb_event_2);
                //     } else if (turndir=="none") {
                //         turndir="right";
                //         const kb_event = new KeyboardEvent('keydown', {'keyCode': 39, 'which': 39});
                //         window.dispatchEvent(kb_event);
                //     }
                // }
                // if (turn_direction=="none") {
                //     if (turndir=="left") {
                //         turndir="none";
                //         const kb_event = new KeyboardEvent('keyup', {'keyCode': 37, 'which': 37});
                //         window.dispatchEvent(kb_event);
                //     } else if (turndir=="right") {
                //         turndir="none";
                //         const kb_event = new KeyboardEvent('keyup', {'keyCode': 39, 'which': 39});
                //         window.dispatchEvent(kb_event);
                //     }
                // }

                // Smooth turn
                if (turn_direction!=turndir) {
                    if (turndir!="none" && turn_direction!="none") {
                        const kb_event = new KeyboardEvent('keyup', {'keyCode': keys_mapping[turndir], 'which': keys_mapping[turndir]});
                        window.dispatchEvent(kb_event);
                        // iframeRef.current.contentWindow.postMessage(JSON.parse(JSON.stringify(kb_event)), "*");
                        // iframeRef.current.contentWindow.dispatchEvent(kb_event);
                        // document.getElementsByClassName('iframegame')[0].contentWindow.postMessage(kb_event);
                        const kb_event_2 = new KeyboardEvent('keydown', {'keyCode': keys_mapping[turn_direction], 'which': keys_mapping[turn_direction]});
                        window.dispatchEvent(kb_event_2);
                        // iframeRef.current.contentWindow.postMessage(JSON.parse(JSON.stringify(kb_event_2)), "*");
                        // iframeRef.current.contentWindow.dispatchEvent(kb_event_2);
                        // document.getElementsByClassName('iframegame')[0].contentWindow.postMessage(kb_event_2);
                        turndir = turn_direction;
                    } else if (turndir=="none" && turn_direction!="none") {
                        const kb_event = new KeyboardEvent('keydown', {'keyCode': keys_mapping[turn_direction], 'which': keys_mapping[turn_direction]});
                        window.dispatchEvent(kb_event);
                        // iframeRef.current.contentWindow.postMessage(JSON.parse(JSON.stringify(kb_event)), "*");
                        // iframeRef.current.contentWindow.dispatchEvent(kb_event);
                        // document.getElementsByClassName('iframegame')[0].contentWindow.postMessage(kb_event);
                        turndir = turn_direction;
                    } else if (turndir!="none" && turn_direction=="none") {
                        const kb_event = new KeyboardEvent('keyup', {'keyCode': keys_mapping[turndir], 'which': keys_mapping[turndir]});
                        window.dispatchEvent(kb_event);
                        // iframeRef.current.contentWindow.postMessage(JSON.parse(JSON.stringify(kb_event)), "*");
                        // iframeRef.current.contentWindow.dispatchEvent(kb_event);
                        // document.getElementsByClassName('iframegame')[0].contentWindow.postMessage(kb_event);
                        turndir = turn_direction;
                    }
                    // console.log(turn_direction);
                }

                // if(accelerate==true) {console.log("accelerate")}
                // if(brake==true) {console.log("brake")}
            }
            get_predictions();
        }
    }
    // Initialize hand detector. Use small model on mobile devices.
    const hands = new Hands({locateFile: (file) => {
    return `https://cdn.jsdelivr.net/npm/@mediapipe/hands/${file}`;
    }});
    if (window.innerWidth < 1280) {
        hands.setOptions({
            maxNumHands: 2,
            modelComplexity: 0,
            minDetectionConfidence: 0.5,
            minTrackingConfidence: 0.5
        });
    } else {
        hands.setOptions({
            maxNumHands: 2,
            modelComplexity: 1,
            minDetectionConfidence: 0.5,
            minTrackingConfidence: 0.5
        });
    }
    hands.onResults(onResults);
    useEffect(() => {
        
        const camera = new Camera(videoElement.current, {
        onFrame: async () => {
            await hands.send({image: videoElement.current});
        },
        width: screenSize.width,
        height: screenSize.height
        });
        camera.start();
    }, [videoElement]);



    const { unityProvider, isLoaded, loadingProgression } = useUnityContext({
        loaderUrl: "unity_game_build/smooth_car/clean_track_webgl.loader.js",
        dataUrl: "unity_game_build/smooth_car/clean_track_webgl.data",
        frameworkUrl: "unity_game_build/smooth_car/clean_track_webgl.framework.js",
        codeUrl: "unity_game_build/smooth_car/clean_track_webgl.wasm",
      });
    const loadingPercentage = Math.round(loadingProgression * 100);
    
    

    return (<> 
        <div className="three-container">
            {isLoaded === false && (
                // We'll conditionally render the loading overlay if the Unity
                // Application is not loaded.
                <div className="loading-overlay">
                <p>Loading... ({loadingPercentage}%)</p>
                {/* <span class="loader"></span> */}
                </div>
            )}
            <Unity className="unity-frame" unityProvider={unityProvider}/>
            {/* <Unity unityProvider={unityProvider} style={{ width: "100%", height: "100%", borderRadius: "10px", border: "solid black", marginTop: "1%", backgroundColor: "transparent", zIndex: 2}}/> */}
            {/* <iframe className="iframegame" ref={iframeRef} src="https://i.simmer.io/@mathieukit/hand-drive" style={{ width: 800, height: 600, borderRadius: "10px", border: "solid black", marginTop: "1%"}}></iframe> */}
            
            
            {/* <Canvas resize = "500px" shadows camera={{ fov: 45 }}>
                <GameScene />
            </Canvas> */}
        </div>
        <Controls />
        <video className="input_video" ref={videoElement}>
            {/* <canvas ref={canvasRef} className="hands-overlay" /> */}
        </video>
        <canvas ref={canvasRef} className="hands-overlay" style={{height: screenSize.height, width: screenSize.width}}/>
    </>
    )
}